import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Box, Typography, Paper } from '@mui/material';

function PrivacyPolicy() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const handleAccept = () => {
    navigate('/confirmar', { state: { email } });
  };

  return (
    <div className="animation-container bg" style={{ minHeight: '100vh', padding: '1.5rem' }}>
      <Box sx={{ maxWidth: 720, margin: '0 auto' }}>
        <Paper elevation={1} sx={{ p: 3, mb: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            Privacy Policy
          </Typography>

          <Typography component="p" paragraph>
            This privacy policy applies to the BANAS app (hereby referred to as &quot;Application&quot;) for mobile devices that was created by E-VAL (hereby referred to as &quot;Service Provider&quot;) as a Free service. This service is intended for use &quot;AS IS&quot;.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            What information does the Application obtain and how is it used?
          </Typography>
          <Typography component="p" paragraph>
            The Application does not obtain any information when you download and use it. Registration is not required to use the Application.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            Does the Application collect precise real time location information of the device?
          </Typography>
          <Typography component="p" paragraph>
            This Application does not collect precise information about the location of your mobile device.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            Do third parties see and/or have access to information obtained by the Application?
          </Typography>
          <Typography component="p" paragraph>
            Since the Application does not collect any information, no data is shared with third parties.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            What are my opt-out rights?
          </Typography>
          <Typography component="p" paragraph>
            You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            Children
          </Typography>
          <Typography component="p" paragraph>
            The Application is not used to knowingly solicit data from or market to children under the age of 13.
          </Typography>
          <Typography component="p" paragraph>
            The Service Provider does not knowingly collect personally identifiable information from children. The Service Provider encourages all children to never submit any personally identifiable information through the Application and/or Services. The Service Provider encourage parents and legal guardians to monitor their children&apos;s Internet usage and to help enforce this Policy by instructing their children never to provide personally identifiable information through the Application and/or Services without their permission. If you have reason to believe that a child has provided personally identifiable information to the Service Provider through the Application and/or Services, please contact the Service Provider (admin@banas.mx) so that they will be able to take the necessary actions. You must also be at least 16 years of age to consent to the processing of your personally identifiable information in your country (in some countries we may allow your parent or guardian to do so on your behalf).
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            Security
          </Typography>
          <Typography component="p" paragraph>
            The Service Provider is concerned about safeguarding the confidentiality of your information. However, since the Application does not collect any information, there is no risk of your data being accessed by unauthorized individuals.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            Changes
          </Typography>
          <Typography component="p" paragraph>
            This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to their Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
          </Typography>
          <Typography component="p" paragraph>
            This privacy policy is effective as of 2026-02-24
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            Your Consent
          </Typography>
          <Typography component="p" paragraph>
            By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by the Service Provider.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            Contact Us
          </Typography>
          <Typography component="p" paragraph>
            If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at admin@banas.mx.
          </Typography>

          <Box component="hr" sx={{ border: 'none', borderTop: '1px solid #ddd', my: 2 }} />

          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            onClick={handleAccept}
            sx={{ mt: 3 }}
          >
            Acepto y continuar
          </Button>
        </Paper>
      </Box>
    </div>
  );
}

export default PrivacyPolicy;
